import type { GameRtpListVariant } from "./computeVariantStyle";

type VariantCopy = {
  title: string;
  tabLabel: string;
};

const DEFAULT_COPY: Record<GameRtpListVariant, VariantCopy> = {
  hot: { title: "🔥 Hot as Hell", tabLabel: "Hot Games" },
  cold: { title: "❄️ Cold as Ice", tabLabel: "Cold Games" },
};

const TRANSLATION_KEYS: Record<GameRtpListVariant, VariantCopy> = {
  hot: {
    title: "game_rtp_list.hot_title",
    tabLabel: "game_rtp_list.hot_tab_label",
  },
  cold: {
    title: "game_rtp_list.cold_title",
    tabLabel: "game_rtp_list.cold_tab_label",
  },
};

const computeVariantCopy = (
  variant: GameRtpListVariant,
  translations?: Record<string, string>,
): VariantCopy => {
  const keys = TRANSLATION_KEYS[variant];
  const fallback = DEFAULT_COPY[variant];
  return {
    title: translations?.[keys.title] ?? fallback.title,
    tabLabel: translations?.[keys.tabLabel] ?? fallback.tabLabel,
  };
};

export default computeVariantCopy;
